/**
 * Observes changes in `.uacf7_conditional[data-condition]` elements and resets select values when hidden.
 */
const observeConditionalFields = () => {

	const observer = new MutationObserver( ( mutations ) => {

		mutations.forEach( ( mutation ) => {

			if ( mutation.type === 'attributes' && mutation.attributeName === 'data-condition' ) {

				const conditionElement = mutation.target;
				const conditionState = conditionElement.getAttribute( 'data-condition' );

				// If the field is hidden (data-condition="false"), reset all select elements inside
				if ( conditionState === 'false' ) {

					const selects = conditionElement.querySelectorAll( 'select' );
					selects.forEach( ( select ) => {

						select.value = ''; // Reset value
						select.dispatchEvent( new Event( 'change' ) ); // Trigger change event

					} );

				}

			}

		} );

	} );

	// Observe all `.uacf7_conditional` elements
	document.querySelectorAll( '.uacf7_conditional' ).forEach( ( element ) => {

		observer.observe( element, { attributes: true, attributeFilter: ['data-condition'] } );

	} );

};

/**
 * Sets select field values based on URL query parameters.
 */
const setSelectValuesFromUrl = () => {

	const urlParams = new URLSearchParams( window.location.search );

	urlParams.forEach( ( value, key ) => {

		const selectElement = document.querySelector( `[name="${key}"]` );

		if ( selectElement ) {

			const matchingOption = Array.from( selectElement.options ).find(
				( option ) => option.value.trim().toLowerCase() === value.trim().toLowerCase()
			);

			if ( matchingOption ) {

				selectElement.value = matchingOption.value;
				selectElement.dispatchEvent( new Event( 'change' ) ); // Ensure CF7 detects the change

			}

		}

	} );

};

/**
 * Initializes all related functionalities for handling form select elements.
 */
const initSelectHandlers = () => {

	// Apply URL-based selections
	setSelectValuesFromUrl();

	// Start observing hidden fields
	observeConditionalFields();

};

document.addEventListener( 'DOMContentLoaded', initSelectHandlers );
